export const validateCPFFormat = (cpf) => {
  return /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(cpf);
};
